import styled from 'styled-components';
import { OnFocusInput } from '../common/index.js';
export const SearchableWrapper = styled.div `
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.White};
`;
export const SearchableInnerWrapper = styled.div `
  width: 100%;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 16px;
  border-radius: 8px;
  padding: 0 12px;
  outline: none;
  border: none;
  border: solid 1px ${({ theme }) => theme.colors.Grey6};
  &:focus-within {
    ${OnFocusInput()};
  }
`;
export const SearchableInput = styled.input `
  overflow: hidden;
  ${({ theme }) => theme.fonts.PoppinsTextMedium}
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  width: 100%;
  outline: none;
  border: none;
  padding-left: 6px;
  font-size: 14px;
  line-height: 22px;
  &::placeholder {
    color: ${({ theme }) => theme.colors.Grey5};
  }
`;
//# sourceMappingURL=BKJSelectSearch.styled.js.map